import Vue from 'vue'
import Router from 'vue-router'
import Home from './pages/Home.vue'
import Events from './pages/Events.vue'
import Event from './pages/Event.vue'
import Edit from './pages/Edit.vue'
import About from './pages/About.vue'
import Profile from './pages/Profile.vue'
import Enter from './pages/Enter.vue'
import TOS from './pages/TOS.vue'
import PP from './pages/PP.vue'
import Reader from './pages/Reader.vue'
import Attendees from './pages/Attendees.vue'
import { user } from './fire.coffee'
import { i18n } from "./main.js";


# Localisation
$tt = (obj) ->
    locale = i18n.locale
    fallback = i18n.fallbackLocale
    obj[locale] || obj[fallback]

Vue.use(Router)

router = new Router
    mode: 'history'
    base: process.env.BASE_URL
    routes: [
        path: '/'
        name: 'home'
        component: Home
        props:
            trash: false
        meta:
            title: en: 'Home', hu: 'Tájékoztató'
    ,
        path: '/demo'
        name: 'events'
        component: Events
        props:
            trash: false
        meta:
            title: en: 'Events', hu: 'Események'
    ,
        path: '/events/:alias'
        name: 'event'
        component: Event
        meta:
            title: en: 'Events', hu: 'Események'
    ,
        path: '/edit/:id'
        name: 'edit'
        component: Edit
        meta:
            title: en: 'Events', hu: 'Események'
    ,
        path: '/attendees/:event'
        name: 'attendees'
        component: Attendees
        meta:
            title: en: 'Events', hu: 'Események'
    ,
        path: '/read/:code'
        name: 'read'
        component: Reader
        meta:
            auth: true
            title: en: 'Events', hu: 'Események'
    ,
        path: '/about'
        name: 'about'
        component: About
        meta:
            title: en: 'Events', hu: 'Események'
        #component: -> import './pages/About.vue'
    ,
        path: '/profile'
        name: 'profile'
        component: Profile
        meta:
            title: en: 'Events', hu: 'Események'
        #component: -> import './pages/Profile.vue'
    ,
        path: '/enter'
        name: 'auth'
        component: Enter
        meta:
            title: en: 'Events', hu: 'Események'
        #component: -> import './pages/Signup.vue'
    ,
        path: '/terms'
        name: 'tos',
        component: TOS
        meta:
            title: en: 'Events', hu: 'Események'
        #component: -> import './pages/TOS.vue'
    ,
        path: '/privacy'
        name: 'pp',
        component: PP
        meta:
            title: en: 'Events', hu: 'Események'
        #component: -> import './pages/TOS.vue'
    ]

router.beforeEach (to, from, next) ->
    needsAuth = to.matched.some (x) -> x.meta.auth
    if needsAuth and !user then next ('name': 'auth')
    else
        title = to.meta.title
        document.title = if title? then $tt(title) else 'Időutazás Kft'
        next()

export default router
